<template>
    <div class="home">

        <img class='background-img' src='../../../assets/images/bg.jpg' alt=""/>
        <div class='card-wrapper'>
            <div class="top-banner mb-5">
                <img src="../../../assets/images/logo.png" alt="">
            </div>

            <div class="container-fluid" v-if="mount">
                <div>
                    <loading-animation></loading-animation>
                    <span class="m-2">Loading the data from the server</span>
                </div>
            </div>

            <div class="container-fluid" v-else>
                <div class="row">
                    <div class="col">
                        <s-form role="form" @submit="onSubmit">

                            <validated-input v-model="model.username" type="text" shadow="0" :rules="{required:true}"
                                             placeholder="" icon="fa fa-user" label="Enter your username"/>

                            <validated-input v-model="model.password" shadow="0" :rules="{required:true}"
                                             placeholder="" icon="fa fa-lock" type="password"
                                             label="Enter your password"/>

                            <div class="card bg-danger mb-2" v-if="errorMessage" v-html="errorMessage"></div>

                            <button type="submit" class="xeo-btn">
                                <span v-if="loading">
                                    <loading-animation/> Validating Credential..
                                </span>
                                <span v-else>
                                    Send Otp
                                </span>
                            </button>
                        </s-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'secure-axios';
import urls from '../../../data/urls';
import { mapActions } from 'vuex';

export default {
    name  : 'Login',
    props : {
        info_message : {
            type    : String,
            default : ''
        }
    },

    data () {
        return {
            loading      : false,
            mount        : true,
            errorMessage : '',
            model        : {
                username : '',
                password : ''
            }
        };
    },

    mounted () {
        this.loadData();
    },

    methods : {
        ...mapActions(['setUser']),
        async onSubmit () {
            // const formValidator = this.$refs.formValidator;
            const that = this;
            this.loading = true;
            axios.form(urls.auth.otpsend, this.model, ['username', 'password']).then(function (response) {
                const json = response.data;
                if (json.success === true) {
                    that.loading = false;
                    // const redirectUrl = sessionStorage.getItem('redirectPath');
                    // that.setUser(json.user);
                    that.$router.push('/otp-verify/' + json.user_id + '/');
                } else {
                    that.loading = false;
                    // formValidator.setErrors(json.errors);
                    // console.log('----a---------------');
                    that.model.username = '';
                    that.model.password = '';
                    that.errorMessage = json.errors.__all__ || '';
                }
                that.loading = false;
            }).catch(function () {
                that.errorMessage = 'There was some errors while communicating <br/>with the server, Please try again later.';
                that.model.username = '';
                that.model.password = '';
                that.loading = false;
            });
        },

        async loadData () {
            const response = await axios.get(urls.auth.status);
            console.log('response : ', response.data);
            if (response.data['public-key']) {
                this.mount = false;
            }
        }
    }
};
</script>

<style scoped>

</style>
